import tw from 'twin.macro';

export const PAGE_WRAPPER_STYLES = tw`max-w-full w-[1000px] mx-12 self-center`;
